import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import on_45route_45change_45global from "/opt/build/repo/middleware/on-route-change.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  on_45route_45change_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}